import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { NotificationUtil } from '@shared/util/notification.util';
import { firstValueFrom } from 'rxjs';
import { MoodActions } from 'app/view/journal/state/mood.actions';
import { MoodApiService } from 'app/view/journal/services/mood-api.service';
import { MoodDTO } from '@data/mood/MoodDTO';
import { isSameDay } from 'date-fns';

export interface MoodStateModel {
  todayMood: MoodDTO;

  moodsForMonth: MoodDTO[];
}

@State<MoodStateModel>({
  name: 'mood'
})
@Injectable()
export class MoodState {
  constructor(private moodApiService: MoodApiService,
              private notificationUtil: NotificationUtil) {
  }

  @Action(MoodActions.GetTodayMood)
  async getTodayMood(ctx: StateContext<MoodStateModel>, _action: MoodActions.GetTodayMood) {
    const state = ctx.getState();
    if (!state.todayMood) {
      const todayMood = await firstValueFrom(this.moodApiService.getTodayMood());

      ctx.patchState({ todayMood });
    }
  }

  @Action(MoodActions.GetMoodsForDateRange)
  async getMoodsForRange(ctx: StateContext<MoodStateModel>, action: MoodActions.GetMoodsForDateRange) {
    const moodsForMonth = await firstValueFrom(this.moodApiService.getMoodsForRange(action.payload));

    ctx.patchState({ moodsForMonth });
  }


  @Action(MoodActions.SelectTodayMood)
  async selectTodayMood(ctx: StateContext<MoodStateModel>, action: MoodActions.SelectTodayMood) {
    await firstValueFrom(this.moodApiService.selectTodayMood(action.mood));

    const todayMood = new MoodDTO();
    todayMood.mood = action.mood;
    todayMood.date = new Date();

    let wasMoodSelected = false;

    const newMoodsForMonth = ctx.getState().moodsForMonth?.map(mood => {
      if (isSameDay(todayMood.date, mood.date)) {
        wasMoodSelected = true;
        return {
          ...mood,
          mood: action.mood
        };
      } else {
        return mood;
      }
    }) ?? [];

    if (!wasMoodSelected) {
      newMoodsForMonth.push({
        mood: action.mood,
        date: new Date()
      });
    }

    ctx.patchState({ todayMood, moodsForMonth: newMoodsForMonth });
    this.notificationUtil.success('COMPONENT.MOOD.TODAY_MOOD_SELECTED_SUCCESS');
  }
}